import React from 'react';
import moment from 'moment';

import {workLogsType} from 'propTypes/products';
import {Section} from 'components/layouts';


class WorkLogs extends React.Component {
    static propTypes = {
        workLogs: workLogsType.isRequired,
    };

    renderWorkLogGroup = workLogGroup => (
        <tr key={workLogGroup.id}>
            <td>
                {[...new Set(workLogGroup.work_logs.map(wl => wl.user.name))].join(', ')}
            </td>
            <td>
                {moment(workLogGroup.start_time).format('DD.MM.YYYY HH:mm:ss')}
            </td>
            <td>
                {workLogGroup.end_time ? moment(workLogGroup.end_time).format('DD.MM.YYYY HH:mm:ss') : '-'}
            </td>
        </tr>
    );

    renderNoWorkLogs = () => (
        <tr>
            <td colSpan={3} className="text-center lead py-3">
                {gettext("No work logs yet")}
            </td>
        </tr>
    );

    render() {
        const {workLogs} = this.props;
        const striped = workLogs.length ? 'table-striped' : '';

        if (workLogs.isLoading) {
            return null;
        }

        const groups = workLogs.groups;

        return (
            <Section title={gettext('Work logs')}>
                <div className="table-responsive">
                    <table className={`table table-sm table-hover ${striped}`}>
                        <thead>
                            <tr>
                                <th>{gettext("Employee")}</th>
                                <th>{gettext("Start")}</th>
                                <th>{pgettext("noun", "End")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groups.length
                                ? groups.map(this.renderWorkLogGroup)
                                : this.renderNoWorkLogs()
                            }
                        </tbody>
                    </table>
                </div>
            </Section>
        );
    }
}

export default WorkLogs;



// WEBPACK FOOTER //
// ./src/components/WorkLogs.js